/**
 * 博士报名路由信息
 */
export default {
  name: 'doctor',
  path: 'doctor',
  component: resolve => require(['../../components/pages/doctor'], resolve),
  redirect: 'doctor/query/materialStatus',
  children: [{
    path: 'query/materialStatus',
    component: resolve => require(['../../components/pages/doctor/query/MaterialStatus'], resolve)
  }, {
    path: 'query/tutorEmail',
    component: resolve => require(['../../components/pages/doctor/query/TutorEmail'], resolve)
  }, {
    path: 'query/reexamineArrange',
    component: resolve => require(['../../components/pages/doctor/query/ReexamineArrange'], resolve)
  }, {
    path: 'query/doctorScore',
    component: resolve => require(['../../components/pages/doctor/query/QueryDoctorScore'], resolve)
  }, {
    path: 'query/doctorInformation',
    component: resolve => require(['../../components/pages/doctor/query/CompleteDoctorInformation'], resolve)
  }]
}



// WEBPACK FOOTER //
// ./src/router/pages/doctor.js